import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import I from "mux-embed";
import M from "hls.js";

var m = /*#__PURE__*/function (_Error) {
  _inherits(m, _Error);

  var _super = _createSuper(m);

  function m(r) {
    var _this;

    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : m.MEDIA_ERR_CUSTOM;
    var o = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, m);

    var a;
    _this = _super.call(this, r);
    _this.name = "MediaError", _this.code = n, _this.fatal = o != null ? o : n >= m.MEDIA_ERR_NETWORK && n <= m.MEDIA_ERR_ENCRYPTED, _this.message || (_this.message = (a = m.defaultMessages[_this.code]) != null ? a : "");
    return _this;
  }

  return _createClass(m);
}( /*#__PURE__*/_wrapNativeSuper(Error)),
    l = m;

l.MEDIA_ERR_ABORTED = 1, l.MEDIA_ERR_NETWORK = 2, l.MEDIA_ERR_DECODE = 3, l.MEDIA_ERR_SRC_NOT_SUPPORTED = 4, l.MEDIA_ERR_ENCRYPTED = 5, l.MEDIA_ERR_CUSTOM = 100, l.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail.",
  3: "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.",
  4: "An unsupported error occurred. The server or network failed, or your browser does not support this format.",
  5: "The media is encrypted and there are no keys to decrypt it."
};
import H from "hls.js";

var k = function k(e, t) {
  return e in t;
},
    L = {
  ANY: "any",
  MUTED: "muted"
},
    E = {
  VOD: "on-demand",
  ON_DEMAND: "on-demand",
  LIVE: "live",
  LL_LIVE: "ll-live",
  DVR: "live:dvr",
  LL_DVR: "ll-live:dvr"
},
    _ = {
  MSE: "mse",
  NATIVE: "native"
},
    A = {
  HEADER: "header",
  QUERY: "query"
},
    pe = Object.values(A),
    f = {
  M3U8: "application/vnd.apple.mpegurl",
  MP4: "video/mp4"
},
    b = {
  HLS: f.M3U8
},
    ye = Object.keys(b),
    fe = [].concat(_toConsumableArray(Object.values(f)), ["hls", "HLS"]);

var T = function T(e, t, r, n) {
  e.addEventListener(t, r, n), e.addEventListener("teardown", function () {
    e.removeEventListener(t, r);
  }, {
    once: !0
  });
};

function C(e, t, r) {
  t && r > t && (r = t);

  for (var n = 0; n < e.length; n++) {
    if (e.start(n) <= r && e.end(n) >= r) return !0;
  }

  return !1;
}

var S = function S(e) {
  var t = e.indexOf("?");
  if (t < 0) return [e];
  var r = e.slice(0, t),
      n = e.slice(t);
  return [r, n];
},
    R = function R(e) {
  var t = e.type;

  if (t) {
    var n = t.toUpperCase();
    return k(n, b) ? b[n] : t;
  }

  var r = e.src;
  return r ? G(r) : "";
},
    G = function G(e) {
  var t = "";

  try {
    t = new URL(e).pathname;
  } catch (_unused) {
    console.error("invalid url");
  }

  var r = t.lastIndexOf(".");
  if (r < 0) return "";
  var o = t.slice(r + 1).toUpperCase();
  return k(o, f) ? f[o] : "";
};

var J = Object.values(L),
    w = function w(e) {
  return typeof e == "boolean" || typeof e == "string" && J.includes(e);
},
    O = function O(_ref, t, r) {
  var e = _ref.autoplay;

  var n = !1,
      o = !1,
      a = w(e) ? e : !!e,
      i = function i() {
    n || T(t, "playing", function () {
      n = !0;
    }, {
      once: !0
    });
  };

  if (i(), T(t, "loadstart", function () {
    n = !1, i(), D(t, a);
  }, {
    once: !0
  }), T(t, "loadstart", function () {
    r || (o = !Number.isFinite(t.duration)), D(t, a);
  }, {
    once: !0
  }), r && r.once(H.Events.LEVEL_LOADED, function (c, d) {
    var u;
    o = (u = d.details.live) != null ? u : !1;
  }), !a) {
    var c = function c() {
      !o || (r != null && r.liveSyncPosition ? t.currentTime = r.liveSyncPosition : Number.isFinite(t.seekable.end(0)) && (t.currentTime = t.seekable.end(0)));
    };

    r && T(t, "play", function () {
      t.preload === "metadata" ? r.once(H.Events.LEVEL_UPDATED, c) : c();
    }, {
      once: !0
    });
  }

  return function (c) {
    n || (a = w(c) ? c : !!c, D(t, a));
  };
},
    D = function D(e, t) {
  if (!t) return;

  var r = e.muted,
      n = function n() {
    return e.muted = r;
  };

  switch (t) {
    case L.ANY:
      e.play().catch(function () {
        e.muted = !0, e.play().catch(n);
      });
      break;

    case L.MUTED:
      e.muted = !0, e.play().catch(n);
      break;

    default:
      e.play().catch(function () {});
      break;
  }
};

var V = function V(_ref2, r, n) {
  var e = _ref2.preload,
      t = _ref2.src;

  var o = function o(p) {
    p != null && ["", "none", "metadata", "auto"].includes(p) ? r.setAttribute("preload", p) : r.removeAttribute("preload");
  };

  if (!n) return o(e), o;

  var a = !1,
      i = !1,
      s = n.config.maxBufferLength,
      c = n.config.maxBufferSize,
      d = function d(p) {
    o(p);
    var y = p != null ? p : r.preload;
    i || y === "none" || (y === "metadata" ? (n.config.maxBufferLength = 1, n.config.maxBufferSize = 1) : (n.config.maxBufferLength = s, n.config.maxBufferSize = c), u());
  },
      u = function u() {
    !a && t && (a = !0, n.loadSource(t));
  };

  return T(r, "play", function () {
    i = !0, n.config.maxBufferLength = s, n.config.maxBufferSize = c, u();
  }, {
    once: !0
  }), d(e), d;
};

import g from "hls.js";

function N(e, t) {
  t.on(g.Events.NON_NATIVE_TEXT_TRACKS_FOUND, function (o, _ref3) {
    var a = _ref3.tracks;
    a.forEach(function (i) {
      var d;
      var s = (d = i.subtitleTrack) != null ? d : i.closedCaptions,
          c = t.subtitleTracks.findIndex(function (_ref4) {
        var u = _ref4.lang,
            p = _ref4.name,
            y = _ref4.type;
        return u == (s == null ? void 0 : s.lang) && p === i.label && y.toLowerCase() === i.kind;
      });
      U(e, i.kind, i.label, s == null ? void 0 : s.lang, "".concat(i.kind).concat(c));
    });
  });

  var r = function r() {
    var i;
    if (!t.subtitleTracks.length) return;
    var o = Array.from(e.textTracks).find(function (s) {
      return s.id && s.mode === "showing" && ["subtitles", "captions"].includes(s.kind);
    }),
        a = "".concat((i = t.subtitleTracks[t.subtitleTrack]) == null ? void 0 : i.type.toLowerCase()).concat(t.subtitleTrack);

    if (o && (t.subtitleTrack < 0 || (o == null ? void 0 : o.id) !== a)) {
      var s = t.subtitleTracks.findIndex(function (_ref5) {
        var c = _ref5.lang,
            d = _ref5.name,
            u = _ref5.type;
        return c == o.language && d === o.label && u.toLowerCase() === o.kind;
      });
      t.subtitleTrack = s;
    }

    o && (o == null ? void 0 : o.id) === a && o.cues && Array.from(o.cues).forEach(function (s) {
      o.addCue(s);
    });
  };

  e.textTracks.addEventListener("change", r), t.on(g.Events.CUES_PARSED, function (o, _ref6) {
    var a = _ref6.track,
        i = _ref6.cues;
    var s = e.textTracks.getTrackById(a);
    if (!s) return;
    var c = s.mode === "disabled";
    c && (s.mode = "hidden"), i.forEach(function (d) {
      var u;
      (u = s.cues) != null && u.getCueById(d.id) || s.addCue(d);
    }), c && (s.mode = "disabled");
  }), t.once(g.Events.DESTROYING, function () {
    e.textTracks.removeEventListener("change", r), e.querySelectorAll("track[data-removeondestroy]").forEach(function (a) {
      a.remove();
    });
  });

  var n = function n() {
    Array.from(e.textTracks).forEach(function (o) {
      var a, i;

      if (!["subtitles", "caption"].includes(o.kind) && o.label === "thumbnails") {
        if (!((a = o.cues) != null && a.length)) {
          var s = e.querySelector('track[label="thumbnails"]'),
              c = (i = s == null ? void 0 : s.getAttribute("src")) != null ? i : "";
          s == null || s.removeAttribute("src"), setTimeout(function () {
            s == null || s.setAttribute("src", c);
          }, 0);
        }

        o.mode !== "hidden" && (o.mode = "hidden");
      }
    });
  };

  t.once(g.Events.MANIFEST_LOADED, n), t.once(g.Events.MEDIA_ATTACHED, n);
}

function U(e, t, r, n, o) {
  var a = document.createElement("track");
  return a.kind = t, a.label = r, n && (a.srclang = n), o && (a.id = o), a.track.mode = "disabled", a.setAttribute("data-removeondestroy", ""), e.append(a), a.track;
}

function Z(e, t) {
  var r = Array.prototype.find.call(e.querySelectorAll("track"), function (n) {
    return n.track === t;
  });
  r == null || r.remove();
}

var K,
    B,
    j = (B = (K = globalThis == null ? void 0 : globalThis.navigator) == null ? void 0 : K.userAgent) != null ? B : "",
    ee = j.toLowerCase().indexOf("android") !== -1,
    x = new WeakMap(),
    Y = "mux.com",
    F,
    q,
    W = (q = (F = M).isSupported) == null ? void 0 : q.call(F),
    te = ee,
    Ne = function Ne() {
  return I.utils.now();
},
    re = I.utils.generateUUID,
    Ue = function Ue(e) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref7$domain = _ref7.domain,
      t = _ref7$domain === void 0 ? Y : _ref7$domain;

  if (!e) return;

  var _S = S(e),
      _S2 = _slicedToArray(_S, 2),
      r = _S2[0],
      _S2$ = _S2[1],
      n = _S2$ === void 0 ? "" : _S2$;

  return "https://stream.".concat(t, "/").concat(r, ".m3u8").concat(n);
},
    ne = function ne(e) {
  if (!e) return;

  var _e$split = e.split("?"),
      _e$split2 = _slicedToArray(_e$split, 1),
      t = _e$split2[0];

  return t || void 0;
},
    oe = function oe(e) {
  if (!e || !e.startsWith("https://stream.")) return;

  var _URL$pathname$slice$s = new URL(e).pathname.slice(1).split(".m3u8"),
      _URL$pathname$slice$s2 = _slicedToArray(_URL$pathname$slice$s, 1),
      t = _URL$pathname$slice$s2[0];

  return t || void 0;
},
    ae = function ae(e) {
  var t, r, n;
  return (t = e == null ? void 0 : e.metadata) != null && t.video_id ? e.metadata.video_id : $(e) && (n = (r = ne(e.playbackId)) != null ? r : oe(e.src)) != null ? n : e.src;
},
    Ke = function Ke(e) {
  var t;
  return (t = x.get(e)) == null ? void 0 : t.error;
},
    Be = function Be(e, t, r) {
  se(t, r);
  var _e$metadata = e.metadata,
      n = _e$metadata === void 0 ? {} : _e$metadata,
      _n$view_session_id = n.view_session_id,
      o = _n$view_session_id === void 0 ? re() : _n$view_session_id,
      a = ae(e);
  n.view_session_id = o, n.video_id = a, e.metadata = n, x.set(t, {});
  var i = ie(e, t);
  de(e, t, i), ue(e, t, i);
  var s = O(e, t, i),
      c = V(e, t, i);
  return {
    engine: i,
    setAutoplay: s,
    setPreload: c
  };
},
    se = function se(e, t) {
  var r = t == null ? void 0 : t.engine;
  r && (r.detachMedia(), r.destroy()), (e == null ? void 0 : e.mux) && !e.mux.deleted && (e.mux.destroy(), delete e.mux), e && (e.removeAttribute("src"), e.load(), e.removeEventListener("error", X), e.removeEventListener("error", h), e.removeEventListener("durationchange", Q), x.delete(e), e.dispatchEvent(new Event("teardown")));
};

function z(e, t) {
  var d;
  var r = R(e);
  if (!(r === f.M3U8)) return !0;
  var o = !r || ((d = t.canPlayType(r)) != null ? d : !0),
      a = e.preferPlayback,
      i = a === _.MSE,
      s = a === _.NATIVE;
  return o && (s || !(W && (i || te)));
}

var ie = function ie(e, t) {
  var r = e.debug,
      n = e.streamType,
      _e$startTime = e.startTime,
      o = _e$startTime === void 0 ? -1 : _e$startTime,
      a = e.metadata,
      i = e.experimentalCmcd,
      s = e.preferCmcd,
      d = R(e) === f.M3U8,
      u = z(e, t);

  if (d && !u && W) {
    var p = {
      backBufferLength: 30,
      renderTextTracksNatively: !1,
      liveDurationInfinity: !0
    },
        y = ce(n),
        P = i ? {
      useHeaders: s === A.HEADER,
      sessionId: a.view_session_id,
      contentId: a.video_id
    } : void 0;
    return new M(_objectSpread(_objectSpread({
      debug: r,
      startPosition: o,
      cmcd: P
    }, p), y));
  }
},
    ce = function ce(e) {
  return [E.LIVE, E.DVR].includes(e) ? {
    backBufferLength: 8
  } : [E.LL_LIVE, E.LL_DVR].includes(e) ? {
    backBufferLength: 4,
    maxFragLookUpTolerance: .001
  } : {};
},
    $ = function $(_ref8) {
  var e = _ref8.playbackId,
      t = _ref8.src,
      r = _ref8.customDomain;
  if (e) return !0;
  if (typeof t != "string") return !1;
  var n = window == null ? void 0 : window.location.href,
      o = new URL(t, n).hostname.toLocaleLowerCase();
  return o.includes(Y) || !!r && o.includes(r.toLocaleLowerCase());
},
    de = function de(e, t, r) {
  var a;
  var n = e.envKey,
      o = $(e);

  if (n || o) {
    var i = e.playerInitTime,
        s = e.playerSoftwareName,
        c = e.playerSoftwareVersion,
        d = e.beaconCollectionDomain,
        u = e.debug,
        p = e.disableCookies,
        y = _objectSpread(_objectSpread({}, e.metadata), {}, {
      video_title: ((a = e == null ? void 0 : e.metadata) == null ? void 0 : a.video_title) || void 0
    }),
        P = function P(v) {
      return typeof v.player_error_code == "string" ? !1 : typeof e.errorTranslator == "function" ? e.errorTranslator(v) : v;
    };

    I.monitor(t, {
      debug: u,
      beaconCollectionDomain: d,
      hlsjs: r,
      Hls: r ? M : void 0,
      automaticErrorTracking: !1,
      errorTranslator: P,
      disableCookies: p,
      data: _objectSpread(_objectSpread({}, n ? {
        env_key: n
      } : {}), {}, {
        player_software_name: s,
        player_software: s,
        player_software_version: c,
        player_init_time: i
      }, y)
    });
  }
},
    ue = function ue(e, t, r) {
  var a;
  var n = z(e, t),
      o = e.src;
  t && n ? (typeof o == "string" ? (t.setAttribute("src", o), e.startTime && (((a = x.get(t)) != null ? a : {}).startTime = e.startTime, t.addEventListener("durationchange", Q, {
    once: !0
  }))) : t.removeAttribute("src"), t.addEventListener("error", X), t.addEventListener("error", h)) : r && o ? (r.on(M.Events.ERROR, function (i, s) {
    var _c;

    var c = (_c = {}, _defineProperty(_c, M.ErrorTypes.NETWORK_ERROR, l.MEDIA_ERR_NETWORK), _defineProperty(_c, M.ErrorTypes.MEDIA_ERROR, l.MEDIA_ERR_DECODE), _c),
        d = new l("", c[s.type]);
    d.fatal = s.fatal, d.data = s, t.dispatchEvent(new CustomEvent("error", {
      detail: d
    }));
  }), t.addEventListener("error", h), N(t, r), r.attachMedia(t)) : console.error("It looks like the video you're trying to play will not work on this system! If possible, try upgrading to the newest versions of your browser or software.");
};

function Q(e) {
  var n;
  var t = e.target,
      r = (n = x.get(t)) == null ? void 0 : n.startTime;

  if (!!r && C(t.seekable, t.duration, r)) {
    var o = t.preload === "auto";
    o && (t.preload = "none"), t.currentTime = r, o && (t.preload = "auto");
  }
}

function X(_x) {
  return _X.apply(this, arguments);
}

function _X() {
  _X = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
    var t, _t$error, r, n, o, _yield$fetch, a;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (e.isTrusted) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            e.stopImmediatePropagation();
            t = e.target;

            if (t != null && t.error) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            _t$error = t.error, r = _t$error.message, n = _t$error.code, o = new l(r, n);

            if (!(t.src && (n !== l.MEDIA_ERR_DECODE || n !== void 0))) {
              _context.next = 18;
              break;
            }

            _context.prev = 8;
            _context.next = 11;
            return fetch(t.src);

          case 11:
            _yield$fetch = _context.sent;
            a = _yield$fetch.status;
            o.data = {
              response: {
                code: a
              }
            };
            _context.next = 18;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](8);

          case 18:
            t.dispatchEvent(new CustomEvent("error", {
              detail: o
            }));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 16]]);
  }));
  return _X.apply(this, arguments);
}

function h(e) {
  var n, o;
  if (!(e instanceof CustomEvent) || !(e.detail instanceof l)) return;
  var t = e.target,
      r = e.detail;
  !r || !r.fatal || (((n = x.get(t)) != null ? n : {}).error = r, (o = t.mux) == null || o.emit("error", {
    player_error_code: r.code,
    player_error_message: r.message
  }));
}

export { L as AutoplayTypes, pe as CmcdTypeValues, A as CmcdTypes, f as ExtensionMimeTypeMap, M as Hls, l as MediaError, b as MimeTypeShorthandMap, _ as PlaybackTypes, E as StreamTypes, U as addTextTrack, fe as allMediaTypes, Ne as generatePlayerInitTime, re as generateUUID, Ke as getError, ce as getStreamTypeConfig, Be as initialize, k as isKeyOf, $ as isMuxVideoSrc, ue as loadMedia, I as mux, Z as removeTextTrack, ie as setupHls, de as setupMux, ye as shorthandKeys, se as teardown, Ue as toMuxVideoURL };